import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ProductTable from './components/ProductTable';
import ArticleCards from './components/ArticleCards';
import AboutSection from './components/AboutSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import DisclaimerSection from './components/DisclaimerSection';

const SITE_URL = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ProductTable />
        <ArticleCards />
        <AboutSection />
        <SafetySection />
        <FAQSection />
        <CTASection />
        <DisclaimerSection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'AllChinaBuy Spreadsheet',
        url: `${SITE_URL}/`,
        description: 'Best AllChinaBuy Spreadsheet 2026 – Updated Finds, Trusted Sellers & Buying Guide',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: 'Best AllChinaBuy Spreadsheet 2026 – Updated Finds, Trusted Sellers & Buying Guide',
        description: 'Discover the best AllChinaBuy Spreadsheet for 2026. Find trusted sellers, verified products, shipping guides, and updated links.',
        image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg',
        author: {
          '@type': 'Organization',
          name: 'China Buying Research Team',
        },
        publisher: {
          '@type': 'Organization',
          name: 'allchinabuy.info',
        },
        datePublished: '2026-01-15',
        dateModified: '2026-06-25',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': `${SITE_URL}/`,
        },
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Is the AllChinaBuy Spreadsheet safe to use?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, the AllChinaBuy Spreadsheet is completely safe when used properly. Our curated collection only includes verified sellers with proven track records. We recommend always using quality control (QC) services before shipping.',
            },
          },
          {
            '@type': 'Question',
            name: 'How often is the AllChinaBuy Spreadsheet updated?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Our AllChinaBuy Spreadsheet is updated weekly with new finds, fresh product links, and updated seller ratings.',
            },
          },
          {
            '@type': 'Question',
            name: 'Does the spreadsheet include seller ratings?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Absolutely. Every product in our AllChinaBuy Spreadsheet includes detailed seller ratings, quality scores, price comparisons, and verified purchase feedback.',
            },
          },
          {
            '@type': 'Question',
            name: 'Can beginners use the AllChinaBuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Definitely. Our AllChinaBuy Spreadsheet is designed to be beginner-friendly with step-by-step guides on how to navigate Taobao, Weidian, and 1688.',
            },
          },
          {
            '@type': 'Question',
            name: 'What platforms does the spreadsheet cover?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'The AllChinaBuy Spreadsheet covers products from Taobao, Weidian, and 1688 — the three largest Chinese e-commerce platforms.',
            },
          },
        ],
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: `${SITE_URL}/`,
          },
        ],
      }) }} />
    </>
  );
}